"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickerField = void 0;
const react_1 = __importDefault(require("react"));
const picker_1 = require("@react-native-picker/picker");
const PickerField_style_1 = require("./PickerField.style");
function PickerField({ firstLabel = '', items, onChange, value, hasError = false, disableFirstLabel = true, style = [], enabled = true, }) {
    return (react_1.default.createElement(picker_1.Picker, { style: [PickerField_style_1.styles.picker, hasError ? PickerField_style_1.styles.error : null, ...style], selectedValue: value, onValueChange: onChange, enabled: enabled },
        !disableFirstLabel && react_1.default.createElement(picker_1.Picker.Item, { label: firstLabel, enabled: true }),
        items.map((item, index) => {
            return (react_1.default.createElement(picker_1.Picker.Item, { label: item.label, value: item.value, key: index }));
        })));
}
exports.PickerField = PickerField;
